<template>
    <div class="app-wrapper">
      <ResponsiveNavbar />
      <main class="main-content">
        <Assortitotaal />
        <ContactUs />
      </main>
      <Footer />
    </div>
  </template>
  
  <script>
import ResponsiveNavbar from '../components/Navbar.vue';
import Assortitotaal from '@/components/Assortitotaal.vue';
import ContactUs from '../components/ContactUs.vue';
import Footer from '../components/Footer.vue';

  
  export default {
    name: "AssortimentPage",
    components: {
      ResponsiveNavbar,
      Assortitotaal,
      ContactUs,
      Footer,
    },
  };
  </script>
  
  <style>
  </style>
  